import { site } from '@/mocks/manhwa';

const testimonials = [
  {
    name: '小鹿',
    role: '入坑两年的条漫读者',
    text: '按题材分类找漫画真的太方便了，冷门宝藏栏目挖到好几部心头好，追更再也不迷路了。',
  },
  {
    name: '阿鱼',
    role: '周末补漫党',
    text: '书单质量很稳，推荐的高分作品几乎没有踩雷的，详情页还能顺藤摸瓜找到同类佳作，很实用。',
  },
  {
    name: 'Momo',
    role: '漫画收藏爱好者',
    text: '人气榜和宝藏榜分开的设计很贴心，新人跟榜单、老读者挖宝藏，各有各的去处。',
  },
];

const stats = [
  { value: '200+', label: '收录韩漫' },
  { value: '7', label: '题材分类' },
  { value: '100%', label: '人工甄选' },
  { value: '每周', label: '持续更新' },
];

export default function AboutStrip() {
  return (
    <section className="bg-primary-600 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-100">
              <i className="ri-double-quotes-l" /> 关于 {site.brand}
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-4xl">
              一份有人情味的韩漫书单
            </h2>
            <p className="mt-4 text-sm leading-7 text-primary-50">
              {site.brand} 是一份由编辑团队人工整理的韩漫推荐书单。我们坚持亲自试读每一部收录作品，只推荐真正好看、值得一追的佳作，从高分人气到冷门宝藏都如实呈现。
            </p>
            <p className="mt-3 text-sm leading-7 text-primary-50">
              不追求堆砌标题，不写空洞的推荐语。我们希望这份好看的韩漫推荐书单，能成为你找漫画、追更新时最顺手的指南。
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl bg-background-50/10 px-4 py-4 text-center">
                  <p className="font-heading text-2xl font-black text-accent-200">{s.value}</p>
                  <p className="mt-1 text-xs text-primary-100">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl bg-background-50/10 p-5">
                <div className="flex gap-1 text-accent-300">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-6 text-background-50">“{t.text}”</blockquote>
                <figcaption className="mt-3 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-background-950">
                    {t.name[0]}
                  </span>
                  <div>
                    <p className="text-sm font-medium text-background-50">{t.name}</p>
                    <p className="text-xs text-primary-100">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}